export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.9.17-1634.50",
  commitId: "2c8efdb7e82f64dad05d7a69993c81ab37f23f3e",
  commitTime: "2026-09-17T16:34:50.000Z",
});
